/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PrescriptionHistoryDialog.vue?vue&type=template&id=063ef49e&scoped=true"
import script from "./PrescriptionHistoryDialog.vue?vue&type=script&lang=js"
export * from "./PrescriptionHistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionHistoryDialog.vue?vue&type=style&index=0&id=063ef49e&lang=css"
import style1 from "./PrescriptionHistoryDialog.vue?vue&type=style&index=1&id=063ef49e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063ef49e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('063ef49e')) {
      api.createRecord('063ef49e', component.options)
    } else {
      api.reload('063ef49e', component.options)
    }
    module.hot.accept("./PrescriptionHistoryDialog.vue?vue&type=template&id=063ef49e&scoped=true", function () {
      api.rerender('063ef49e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/PrescriptionHistoryDialog.vue"
export default component.exports